import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { companyInfo } from '../data/mock';

const HeroSection = () => {
  const scrollToAbout = () => {
    const element = document.querySelector('#about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-navy-900">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #C9A962 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900" />
      
      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-gold-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 mb-8">
              <span className="w-2 h-2 bg-gold-500 rounded-full animate-pulse" />
              <span className="text-white/70 text-sm font-medium">Administração & Marketing</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              <span className="block">Sua Marca,</span>
              <span className="block text-gold-500">Nossa Missão</span>
            </h1>

            <p className="text-lg md:text-xl text-white/70 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              Administração inteligente, marketing estratégico e marcas que se destacam. Cuidamos do seu negócio como se fosse nosso.
            </p>

            {/* Call to Action Text */}
            <p className="text-base md:text-lg text-gold-400 font-medium mb-8 max-w-xl mx-auto lg:mx-0">
              Dê o primeiro passo do seu negócio: crie sua primeira logo e sua landing page profissional.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href={`https://wa.me/${companyInfo.contact.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-2 bg-gold-500 hover:bg-gold-600 text-navy-900 px-8 py-4 rounded-full font-semibold text-base transition-all duration-300 hover:shadow-xl hover:shadow-gold-500/25 w-full sm:w-auto justify-center"
              >
                Iniciar Conversa
                <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
              <a
                href="#services"
                onClick={(e) => { e.preventDefault(); document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="flex items-center gap-2 text-white/80 hover:text-gold-500 px-8 py-4 font-medium transition-colors duration-300 w-full sm:w-auto justify-center"
              >
                Nossos Serviços
              </a>
            </div>
          </div>

          {/* Logo Display - Clean Design */}
          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="relative">
              {/* Glow Effect */}
              <div className="absolute inset-0 bg-gold-500/20 rounded-full blur-3xl scale-125" />
              
              {/* Logo Symbol Container */}
              <div className="relative flex flex-col items-center gap-8">
                {/* Logo Circular */}
                <div className="relative">
                  <div className="absolute inset-0 bg-gold-500/30 rounded-full blur-2xl animate-pulse" />
                  <img 
                    src="https://customer-assets.emergentagent.com/job_dumangin-admin/artifacts/leh66jbq_2e59b12d0_logosimboloGOODquality.png"
                    alt="DumanginADM Logo"
                    className="relative w-40 h-40 md:w-52 md:h-52 lg:w-64 lg:h-64 object-contain rounded-full shadow-2xl"
                  />
                </div>

                {/* Brand Name Below */}
                <div className="text-center">
                  <div className="text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.3em] text-white">
                    DUMANGIN<span className="text-gold-500 font-semibold">ADM</span>
                  </div>
                  <div className="flex items-center justify-center gap-3 mt-3">
                    <div className="w-8 h-px bg-gold-500/50" />
                    <span className="text-gold-500 text-lg">◆</span>
                    <div className="w-8 h-px bg-gold-500/50" />
                  </div>
                  <p className="text-white/50 text-sm tracking-widest mt-2 uppercase">
                    Administração & Marketing
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button 
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/50 hover:text-gold-500 transition-colors duration-300 animate-bounce"
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default HeroSection;
